import { WsReactBaseService } from '@thewhite/react-base-components';
import { BaseActions } from '@thewhite/react-global-module/lib/actions';
import { CollectionDTOInterface } from '@thewhite/react-global-module/lib/interfaces';
import { api } from '../../../config/api';
import { globalConfig } from '../../../config/globalConfig';
import { OrganizationCardParams } from '../interfaces/organizationCardParams';
import { OrganizationListParams } from '../interfaces/organizationListParams';
import { OrganizationMyAccessParams } from '../interfaces/organizationMyAccessParams';
import { OrganizationPageParams } from '../interfaces/organizationPageParams';
import { Organization, OrganizationDTO, OrganizationType } from '../models/organization';
import { OrganizationMin, OrganizationMinDTO, OrganizationMinType } from '../models/organizationMin';

export class OrganizationActions extends BaseActions {
    static DEFAULT_URL = `${globalConfig.api}/organization-service/organization/`;
    static api         = api;

    /**
     * Получение списка организаций
     * @param queryParams
     */
    static list = (queryParams: OrganizationListParams): Promise<OrganizationMin[]> => {
        return OrganizationActions.ARRAY_API_RESOURCE<OrganizationMinDTO, OrganizationMin>({
            queryParams,
            url: 'list',
            model: OrganizationMin,
            modelType: OrganizationMinType,
        });
    }

    /**
     * Получение постраничного списка организаций
     * @param queryParams
     */
    static page = (queryParams: OrganizationPageParams): Promise<CollectionDTOInterface<OrganizationMin>> => {
        return OrganizationActions.COLLECTION_API_RESOURCE<OrganizationMinDTO, OrganizationMin>({
            queryParams,
            url: 'page',
            model: OrganizationMin,
            modelType: OrganizationMinType,
        });
    }

    /**
     * Получение одной организации
     * @param id
     */
    static get = (id: string): Promise<Organization | null> => {
        return OrganizationActions.MODEL_API_RESOURCE<OrganizationDTO, Organization>({
            url: id,
            model: Organization,
            modelType: OrganizationType,
        });
    }

    /**
     * Получение доступных организаций
     * @param queryParams
     */
    static myAccess = (queryParams: OrganizationMyAccessParams): Promise<Organization[]> => {
        return OrganizationActions.ARRAY_API_RESOURCE<OrganizationDTO, Organization>({
            queryParams,
            url: 'my-access',
            model: Organization,
            modelType: OrganizationType,
        });
    }

    /**
     * Создание организации
     * @param bodyParams
     */
    static create = (bodyParams: OrganizationCardParams): Promise<Organization | null> => {
        return OrganizationActions.MODEL_API_RESOURCE<OrganizationDTO, Organization>({
            bodyParams,
            url: 'create',
            model: Organization,
            modelType: OrganizationType,
            method: WsReactBaseService.POST_METHOD,
        });
    }

    /**
     * Обновление организации
     * @param id
     * @param bodyParams
     */
    static update = (id: string, bodyParams: OrganizationCardParams): Promise<Organization | null> => {
        return OrganizationActions.MODEL_API_RESOURCE<OrganizationDTO, Organization>({
            bodyParams,
            url: `${id}/update`,
            model: Organization,
            modelType: OrganizationType,
            method: WsReactBaseService.POST_METHOD,
        });
    }

    /**
     * Удаление организации
     * @param id
     */
    static delete = (id: string): Promise<null> => {
        return OrganizationActions.API_RESOURCE(`${id}/delete`, WsReactBaseService.POST_METHOD);
    }

    /**
     * Активация организации
     * @param id
     */
    static activate = (id: string): Promise<null> => {
        return OrganizationActions.API_RESOURCE(`${id}/activate`, WsReactBaseService.POST_METHOD);
    }

    /**
     * Деактивация организации
     * @param id
     */
    static deactivate = (id: string): Promise<null> => {
        return OrganizationActions.API_RESOURCE(`${id}/deactivate`, WsReactBaseService.POST_METHOD);
    }
}
